import { render } from "./MenuPC.vue?vue&type=template&id=d60499d4&scoped=true"
import script from "./MenuPC.vue?vue&type=script&lang=js"
export * from "./MenuPC.vue?vue&type=script&lang=js"

import "./MenuPC.vue?vue&type=style&index=0&id=d60499d4&scoped=true&lang=scss"

import exportComponent from "/home/cubel/PhpstormProjects/failder/vue-failder/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d60499d4"]])

export default __exports__